// Configuration for the client-side (canvas) avatar used in video/avatar mode.
// Defaults mirror the working avatar_test.html. Any field can be overridden per
// deployment via widget props or the PUBLIC_AVATAR_* environment variables.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var defaultAvatarConfig = {
    sdkUrl: 'https://d3he3ojp4sm7l0.cloudfront.net/talkbot-edge.js',
    assetBase: 'https://dgopie9fnmj3j.cloudfront.net',
    modelBase: 'https://d1o3m16nywldaw.cloudfront.net',
    avatar: 'fatima_v1',
    tokenApiUrl: 'https://yr59j88230.execute-api.us-east-1.amazonaws.com/dev/api/token',
    agentId: '0606745c-d000-49a9-90b0-362b2dd167e7',
    // abaya ships 3 idle clips; play the 1st twice, then 2nd and 3rd once, then loop.
    idleOrder: [
        { clip: 0, repeat: 2 },
        { clip: 1, repeat: 1 },
        { clip: 2, repeat: 0 },
    ],
    render: 'local',
    gatewayUrl: 'http://127.0.0.1:8300',
};
// Webpack's DotenvPlugin substitutes literal `process.env.KEY` occurrences at
// build time — it cannot see through an alias like `const e = process.env`,
// which silently yields undefined in the browser. Keep every read literal.
var envOverrides = function () {
    var o = {};
    var sdkUrl = process.env.PUBLIC_AVATAR_SDK_URL;
    var assetBase = process.env.PUBLIC_AVATAR_ASSET_BASE;
    var modelBase = process.env.PUBLIC_AVATAR_MODEL_BASE;
    var avatar = process.env.PUBLIC_AVATAR_ID;
    var tokenApiUrl = process.env.PUBLIC_AVATAR_TOKEN_API;
    var agentId = process.env.PUBLIC_AVATAR_AGENT_ID;
    var render = process.env.PUBLIC_AVATAR_RENDER;
    var gatewayUrl = process.env.PUBLIC_AVATAR_GATEWAY_URL;
    if (sdkUrl)
        o.sdkUrl = sdkUrl;
    if (assetBase)
        o.assetBase = assetBase;
    if (modelBase)
        o.modelBase = modelBase;
    if (avatar)
        o.avatar = avatar;
    if (tokenApiUrl)
        o.tokenApiUrl = tokenApiUrl;
    if (agentId)
        o.agentId = agentId;
    if (render === 'local' || render === 'gateway' || render === 'livekit')
        o.render = render;
    if (gatewayUrl)
        o.gatewayUrl = gatewayUrl;
    return o;
};
/** Merge precedence: explicit overrides > env vars > built-in defaults. */
export var getAvatarConfig = function (overrides) { return (__assign(__assign(__assign({}, defaultAvatarConfig), envOverrides()), (overrides || {}))); };
